import axios from "axios";

export default {
  namespaced: true,
  state: {
    wfVentasAno: [],
    verMontoCantidad: false,
    peticionCliente: false,
    DatosCliente: null
  },
  mutations: {
    set_verMontoCantidad(state) {
      state.verMontoCantidad = !state.verMontoCantidad;
    },
    set_peticionCliente(state, data) {
      state.peticionCliente = data;
    },
    clr_verMontoCantidad(state) {
      state.verMontoCantidad = false;
    },
    set_wfVentasAno(state, data) {
      state.wfVentasAno = data;
    },
    clr_wfVentasAno(state) {
      state.wfVentasAno = [];
    },
    set_DatosCliente(state, data) {
      state.DatosCliente = data
    }
  },
  actions: {
    cargarDatosCliente: async ({ rootState, commit }, id) => {
      try {
        let responsePromise = [];
        commit("set_peticionCliente", true);
        let respuesta = axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              cia: id.idCia,
              program: "EstadisticasVentasJson",
              userweb: id.userw,
              div: rootState.division,
              dep: rootState.departam,
              cat: rootState.categoria,
              ejec: id.ejec,
              vend: id.vend,
              clie: id.clie,
              vergrupo: id.GrupoCli,
              dia: id.dia,
              sem: id.sem,
              mes: id.mes,
              ano: id.annio,
              opc: id.opc,
            },
          }
        );
        responsePromise.push(respuesta);
        let responses = await Promise.all(responsePromise);
        commit("set_peticionCliente", false);
        if (responses[0].status == 200) {
          let dataP = responses[0].data;
          let ResumenVentas = dataP.dsVentas;

          if (Object.entries(ResumenVentas).length !== 0) {
            if (ResumenVentas.wfVentasAno) {
              let dataAnnio = ResumenVentas;
              commit("set_wfVentasAno", {
                datos: dataAnnio,
                id: id.compania,
              });
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    GetDatosCliente: async ({ rootState, commit }, param) => {
      try {
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              cia: param.cia,
              program: "ConsultaClienteJson",
              cliente: param.cliente,
              rif: param.rif,
              usuario: rootState.dataUser.Usuario,
              opc: 6,
            },
          }
        );
        let status = await respuesta.status;
        if (status == 200) {
          let data = await respuesta.data;
          let ttDatos = await data.ttDatos;
          commit("set_DatosCliente", ttDatos[0]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  getters: {},
};